import { PickListItem, JsonItem, AppUserAccess, AppUserExtended } from "../list-management.objects"; 
import { SpecialCaseEntity } from "../list-management.form-sections";
import _ from "lodash";

declare var $: any;
export class UserAccessSelector implements SpecialCaseEntity {
    id: string;
    sectionId: string;
    propertyName: string;
    accessPickListName: string;
    centerPickListName: string;
    limtedCenterPickListName: string;

    isRequired: boolean;
    displayName: string;

    accessList: PickListItem[];
    limitedCenterList: PickListItem[];
    centerList: PickListItem[];

    accessTable: any;
    initialAccess: AppUserAccess[];
    addedAccess: AppUserAccess[];

    currentAppUser: AppUserExtended = null;


    constructor(id: string, propteryName: string, accessListName: string, additionalPickLists: string[], displayName: string, isRequired: boolean) {
        this.id = id;
        this.sectionId = `user-access-${this.id}`;
        this.propertyName = propteryName;
        this.accessPickListName = accessListName;
        this.centerPickListName = additionalPickLists.find(name => name.includes("pl-center"));
        this.limtedCenterPickListName = additionalPickLists.find(name => name.includes("pl-limited-center"));
        this.addedAccess = [];
        this.initialAccess = [];
        this.displayName = displayName;
        this.isRequired = isRequired;
    }

    generateHtml(): string {
        let requiredClass = "";
        if (this.isRequired) requiredClass = "required";
        let displayNameHtml = "";
        if (this.displayName) {
            displayNameHtml = `<div class="acess-selector-label"><label for="" class="${requiredClass}">${this.displayName}</label></div>`
        }

        let html = `
            ${displayNameHtml}
            <p class="access-selector-description">Use the tool below to give user access for the selected content. To add access, select a access type and the appropriate center, then click "Add Access". To remove access, expand it in the list by clicking on it, then click "Remove Access".</p>
            <div class="user-affiliation-selection-block mb-4" id="user-access-${this.id}">
                <div class="reset-section-block d-flex justify-content-between align-items-center py-2 px-3">
                    <div id="user-display-title-${this.id}" class="reset-section-title d-none">
                        
                    </div>
                    <div class="reset-user-affiliation">
                        <a id="reset-user-access-btn-${this.id}" class="btn btn-secondary revampp-white-btn font-size14">
                            Reset
                        </a>
                    </div>
                </div>
                <div class="add-user-affiliation-block py-3">
                    <div class="row px-3">
                        <div class="col-md-6 col-12 affiliation-block-form">
                            <div class="row mb-2">
                                <div class="form-group col">
                                    <label class="mb-0">Center:</label>
                                    <select class="selectpicker dropdown list-management-dropdown" id="revampp-center-select-${this.id}" title="-- Select a Center --" data-width="100%" data-container="body" data-size="5">
                                        
                                    </select>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="form-group col">
                                    <label class="mb-0">Access Type:</label>
                                    <select class="selectpicker dropdown list-management-dropdown" id="revampp-access-select-${this.id}" title="-- Select an Access Type --" data-width="100%" data-container="body" data-size="5">
                                        
                                    </select>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col-auto">
                                    <a class="btn btn-small revampp-blue-btn text-decoration-none add-access-btn disabled" id="add-access-btn-${this.id}">+ Add Access</a>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-12 affiliation-block-list mt-md-0 mt-3">
                            <div>
                                <div class="mb-1">
                                    <span class="font-weight-bold">Added Access: </span><span id="added-access-count-${this.id}">0</span>
                                </div>
                                <div class="revampp-access-list-section">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
            `
        return html;
    }

    initialize(pickLists: JsonItem[], entityArr: any[]): void {
        // Create Lists
        this.accessList = [];
        this.centerList = [];

        let foundAccessList = pickLists.find(list => list.Id == this.accessPickListName);
        let foundCenterList = pickLists.find(list => list.Id == this.centerPickListName);
        let foundLimitedCenterList = pickLists.find(list => list.Id == this.limtedCenterPickListName);

        if (!foundAccessList || !foundCenterList) return;

        this.accessList = foundAccessList.Json;
        this.centerList = foundCenterList.Json;
        this.limitedCenterList = foundLimitedCenterList.Json;

        // Dropdown for Access + Centers
        let accessArr: string[][] = [];
        this.accessList.forEach(access => accessArr.push([access.Value, access.Id.toString()]));
        let centerArr: string[][] = [];
        this.limitedCenterList.forEach(center => centerArr.push([center.Value, center.Id.toString()]));
        this.generateDropdown(`revampp-access-select-${this.id}`, accessArr);
        this.generateDropdown(`revampp-center-select-${this.id}`, centerArr);

        //initialize table
        this.clearAccessList();

        // initialize Search functionality
        this.initializeSearchTool();

        // Store Additional User Info
        if (entityArr.length > 0) {
            // access are only done with one user
            this.currentAppUser = entityArr[0];
        }
        this.updateDisplayUser();
    }

    getValue(): any {
        return this.addedAccess;
    }

    validate(): boolean {
        return true;
    }

    updateDisplayUser(): void {
        let displayBlock: JQuery<HTMLElement> = $(`#user-display-title-${this.id}`);
        displayBlock.addClass("d-none");

        if (this.currentAppUser) {
            let name = `${this.currentAppUser.AppUser.FirstName} ${this.currentAppUser.AppUser.LastName}`;
            displayBlock.text(name);
            displayBlock.removeClass("d-none");
        }
    }

    getDisplayAccess(accessId: number): string {
        let returnVal = "";
        let foundAccess = this.accessList.find(access => access.Id == accessId);
        if (foundAccess) {
            returnVal = foundAccess.Value;
        }
        return returnVal;
    }

    getDisplayCenter(centerId: number): string {
        let returnVal = "";
        let foundCenter = this.centerList.find(center=> center.Id == centerId);
        if (foundCenter) {
            returnVal = foundCenter.Value;
        }
        return returnVal;
    }

    updateStoredValues(entityArray: any[]): void {
        // This isn't going to work for mulitple items;
        if (entityArray.length <= 0) return;
        let targetEntity = entityArray[0];
        let initialValues = _.get(targetEntity, this.propertyName);

        this.initialAccess = _.cloneDeep(initialValues);
        this.addedAccess = _.cloneDeep(initialValues);
        this.updateAccessList();
    }

    checkChanged(): boolean {
        if (this.initialAccess.length != this.addedAccess.length) {
            return true;
        }

        let isChanged = false;
        this.initialAccess.forEach(access => {         
            let foundAccess = this.addedAccess.some(addedAccess => addedAccess.AccessTypeId == access.AccessTypeId && addedAccess.CenterId == access.CenterId);
            if (!foundAccess) {
                isChanged = true;
            }
        });

        return isChanged;
    }

    clearAccessList(): void {
        $(`#${this.sectionId}`).find(".revampp-access-list-section").empty();
    }

    updateAccessList(): void {
        this.clearAccessList();
        let accessListHtml = "";
        for (let i = 0; i < this.addedAccess.length; i++) {
            let currentAccess: AppUserAccess = this.addedAccess[i];

            let removeBtn = "";
            if (this.limitedCenterList.some(center => center.Id == currentAccess.CenterId)) {
                removeBtn = `
                    <div class="mt-2">
                        <a class="btn btn-small revampp-white-btn text-decoration-none delete-access-btn" id="delete-access-btn-${i}">Remove Access</a>
                    </div>
                `
            }


            let expandContent = `
                <div id="access-list-collapse-${i}" class="collapse p-1">
                    <div>
                        <b>Center</b>: ${this.getDisplayCenter(currentAccess.CenterId)} 
                    </div>
                    <div>
                        <b>Access Type</b>: ${this.getDisplayAccess(currentAccess.AccessTypeId)} 
                    </div>
                    ${removeBtn}
                </div>
            `

            accessListHtml += `
                <div class="affiliation-list-item">
                    <div class="affiliation-item-block collapsed" data-toggle="collapse" data-target="#access-list-collapse-${i}">
                        <div class="affiliation-block-title">
                            ${this.getDisplayAccess(currentAccess.AccessTypeId)} (${this.getDisplayCenter(currentAccess.CenterId)})
                        </div>
                    </div>
                    ${expandContent}
                </div>
            `
        }

        $(`#${this.sectionId}`).find(".revampp-access-list-section").html(accessListHtml);
        $(`#added-access-count-${this.id}`).text(this.addedAccess.length);

        $(`#${this.sectionId}`).find(".delete-access-btn").off().on("click", (e) => {
            let elementId = $(e.currentTarget).attr("id");
            let arrayIndex: number = parseInt(elementId.replace("delete-access-btn-", ""));
            if (arrayIndex != NaN) {
                this.addedAccess.splice(arrayIndex, 1);
                this.updateAccessList();
            }
        })
    }

    initializeSearchTool(): void {
        // Reset Dropdowns
        $(`#reset-user-access-btn-${this.id}`).on('click', (e) => {
            this.clearValidation();
            this.resetDropdowns();
        });


        $(`#add-access-btn-${this.id}`).on('click', () => {
            // Validate
            let isValid: boolean = this.validateAccessForm();
            if (!isValid) return;

            // Get Access
            let accessTypeId = parseInt($(`#revampp-access-select-${this.id}`).val().toString());
            let centerId = parseInt($(`#revampp-center-select-${this.id}`).val().toString());

            if (accessTypeId == NaN || centerId == NaN) {
                return;
            }

            let newAccess: AppUserAccess = {
                Id: 0,
                AppUserId: 0,
                AccessTypeId: accessTypeId,
                CenterId: centerId
            }

            // Add Access to List of Access (no duplicates)
            let foundAccess = this.addedAccess.find(access => access.AccessTypeId == newAccess.AccessTypeId && access.CenterId == newAccess.CenterId);
            if (!foundAccess) {
                this.addedAccess.push(newAccess);
            }

            // Update Added Access List
            this.updateAccessList();
            this.resetDropdowns();
            this.clearValidation();
        });

        $(`#revampp-center-select-${this.id}`).on("changed.bs.select", () => {
            let centerSelected = $(`#revampp-center-select-${this.id}`).val();
            let accessTypeSelected = $(`#revampp-access-select-${this.id}`).val();

            if (!centerSelected || !accessTypeSelected) {
                $(`#add-access-btn-${this.id}`).addClass("disabled");
            }
            else {
                $(`#add-access-btn-${this.id}`).removeClass("disabled");
            }
        });

        $(`#revampp-access-select-${this.id}`).on("changed.bs.select", () => {
            let centerSelected = $(`#revampp-center-select-${this.id}`).val();
            let accessTypeSelected = $(`#revampp-access-select-${this.id}`).val();

            if (!centerSelected || !accessTypeSelected) {
                $(`#add-access-btn-${this.id}`).addClass("disabled");
            }
            else {
                $(`#add-access-btn-${this.id}`).removeClass("disabled");
            }
        })
    }

    validateAccessForm(): boolean {
        let isValid = true;

        // Access Type
        let accessTypeSelected = $(`#revampp-access-select-${this.id}`).val();
        if (!accessTypeSelected) {
            $(`#revampp-access-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
            isValid = false;
        }
        else {
            $(`#revampp-access-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-invalid").addClass("is-valid");
        }

        // Center
        let centerSelected = $(`#revampp-center-select-${this.id}`).val();
        if (!centerSelected) {
            $(`#revampp-center-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
            isValid = false;
        }
        else {
            $(`#revampp-center-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-invalid").addClass("is-valid");
        }

        return isValid;
    }

    clearValidation() {
        $(`#revampp-center-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").removeClass("is-invalid");
        $(`#revampp-access-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").removeClass("is-invalid");
    }

    resetDropdowns() {
        $(`#revampp-center-select-${this.id}`).val("").trigger("change");
        $(`#revampp-access-select-${this.id}`).val("").trigger("change");
    }

    generateDropdown(dropdownId: string, options: string[][]): void {
        // Remove any previous options
        $(`#${dropdownId}`).find("option").remove();

        $(`#${dropdownId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });
        if (options != undefined) {
            options.sort((x1: string[], x2: string[]) => {
                if (x1[0].startsWith("-") && !x2[0].startsWith("-")) {
                    return 1;
                }
                else if (x2[0].startsWith("-") && !x1[0].startsWith("-")) {
                    return -1;
                }
                else {
                    return x1[0].localeCompare(x2[0]);
                }
            });
            options.forEach((element: string[]) => {
                $(`#${dropdownId}`).append(new Option(element[0], element[1], false, false))
            })
        }

        $(`#${dropdownId}`).selectpicker("refresh");
    }

    getDisplayValue(indexVal = -1): string {
        return "";
    }
}